import React, { useState,
	useEffect }            from "react";
import Grid                from '@mui/material/Grid';
import Table               from '@mui/material/Table';
import TableBody           from '@mui/material/TableBody';
import TableCell           from '@mui/material/TableCell';
import TableContainer      from '@mui/material/TableContainer';
import TableHead           from '@mui/material/TableHead';
import TableRow            from '@mui/material/TableRow';
import Paper               from '@mui/material/Paper';

import ActionBtn           from './actionBtn';
import { articleListing }  from '../../../apis/article';

const initialState = {
    data: false,
}

export default function Directory () {
	const [{ data }, setState] = useState (initialState);

	useEffect(() => {
		document.title = 'Dashboard | Overseas.one';

		const getData = async () => {
			try {
				const resp = await articleListing ();
				setState (prevState => ({ ...prevState, 'data': resp }));

			} catch (err) {
				setState (prevState => ({ ...prevState, 'data': null }));
				console.error (err);
			}
		}
		getData ();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (data === null)
		return (
			<p>Some network issue. Please try later.</p>
		);

	if (!data || !data.length)
		return (
			<h4 style={{margin: '50px 0 0 50px'}}>Loading...</h4>
		);

	return (
		<Grid spacing={1} container style={{marginTop: '20px'}}>
			<Grid item xs={false} md={1}>
			</Grid>
			<Grid item xs={12} md={10} style={{}}>
				<TableContainer component={Paper}>
					<Table sx={{ minWidth: 650 }} aria-label="simple table">
						<TableHead>
							<TableRow>
								<TableCell><b>Title</b></TableCell>
								<TableCell align="right"><b>URL</b></TableCell>
								<TableCell align="right"><b>Status</b></TableCell>
								<TableCell align="right"><b>Actions</b></TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{ data.length && data.map ((row, index) => (
								<TableRow
									key={row._id}
									sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
								>
									<TableCell component="th" scope="row">
										{row.title}
									</TableCell>
									<TableCell align="right">{row.url}</TableCell>
									<TableCell align="right">
										{row.status}
									</TableCell>
									<TableCell align="right">
										<ActionBtn row={row} />
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</Grid>
		</Grid>
	);
}
